export default "__VITE_ASSET__BdTpltXN__"